import { oidcConfig } from './okta-config'

const defaultRedirection = process.env.REACT_APP_DEFAULT_REDIRECTION
const salesforceBaseUrl = process.env.REACT_APP_SALESFORCE_BASE_URL
const multiLoginSiteUrl = process.env.REACT_APP_MULTILOGIN_SITE_URL

const reactRoutes: any = {
  home: '/',
  welcome: '/welcome',
  login: '/login',
  multiLogin: '/multi-login',
  loginCallback: '/implicit/callback', // This is where auth is handled after redirection
  gatewayCallback: '/gateway/callback',
  impersonate: '/impersonate',
  impersonateGateway: '/impersonateGateway',
  passwordExpired: '/password-expired',
  mfa: '/mfa',
  membershipExpired: '/membership-expired',
  subscriptionAgreement: '/subscription-agreement',
  forgotLoginName: '/forgot-login-name',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  changePassword: '/change-password',
  logout: '/logout',
  noAccess: '/no-access',
  expirePassword: '/expire-password',
  enroll: '/enroll',
  forceEmailEnroll: '/force-email-enroll',
  updateEnrollment: '/update-enrollment', // DEPRECATED - use manageMfa instead
  updateEnrollmentOtpForm: '/update-enrollment-otp-form', // DEPRECATED
  manageMfa: '/manage-mfa',
  addMfaFactor: '/manage-mfa/add-factor',
  passwordSecurity: '/password-and-security',
  multiLoginSwitchAccountLogout: '/multi-login-switch-account-logout',
}

const reDirections: any = {
  defaultRedirection,
  BCOM: {
    needHelp: `${defaultRedirection}/article/8431`,
    login: `${defaultRedirection}/login`,
    join: `${defaultRedirection}/join`,
    noAccess: `${defaultRedirection}/messaging/no-access-to-application`,
    home: `${defaultRedirection}/home`,
    dashboard: `${defaultRedirection}/dashboard`,
  },
  oktaLogout: (idToken: string, redirectUri: string) =>
    `${oidcConfig.issuer}/v1/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${redirectUri}`,
  inactiveMemberRedirection: `${salesforceBaseUrl}/customers/apex/Communities_Inactives?id=`,
  multiLoginChangePassword: `${multiLoginSiteUrl}/change-password`,
}

const routesConfig: any = {
  ...reactRoutes,
  ...reDirections,
}

export default routesConfig
